import React from "react";

interface OwnProps {
  isChecked?: boolean;
}

const SignupCheckIcon = ({ isChecked = false }: OwnProps) => {
  return (
    <>
      {isChecked ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="26"
          viewBox="0 0 26 26"
          fill="none"
        >
          <g clipPath="url(#clip0_83_46488)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26ZM18.9696 9.69864C19.3002 9.27359 19.2236 8.66102 18.7986 8.33043C18.3736 7.99983 17.761 8.0764 17.4304 8.50145L12.2213 15.1989C12.1055 15.3478 11.8876 15.3671 11.7473 15.2409L8.45225 12.2753C8.052 11.9151 7.43552 11.9476 7.0753 12.3478C6.71507 12.7481 6.74752 13.3645 7.14777 13.7248L10.4429 16.6903C11.4245 17.5738 12.9497 17.4385 13.7605 16.3961L18.9696 9.69864Z"
              fill="#2275EE"
            />
          </g>
          <defs>
            <clipPath id="clip0_83_46488">
              <rect width="26" height="26" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="26"
          viewBox="0 0 26 26"
          fill="none"
        >
          <g clipPath="url(#clip0_83_46494)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26ZM18.9696 9.69864C19.3002 9.27359 19.2236 8.66102 18.7986 8.33043C18.3736 7.99983 17.761 8.0764 17.4304 8.50145L12.2213 15.1989C12.1055 15.3478 11.8876 15.3671 11.7473 15.2409L8.45225 12.2753C8.052 11.9151 7.43552 11.9476 7.0753 12.3478C6.71507 12.7481 6.74752 13.3645 7.14777 13.7248L10.4429 16.6903C11.4245 17.5738 12.9497 17.4385 13.7605 16.3961L18.9696 9.69864Z"
              fill="#C3C3C3"
            />
          </g>
          <defs>
            <clipPath id="clip0_83_46494">
              <rect width="26" height="26" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )}
    </>
  );
};

export default SignupCheckIcon;